// default
export const NATION = 'nation';
export const NATION_SLICE_NAME = `${NATION}Slice`;

// action
export const GET_NATION_LIST = `${NATION}/getNation`;
export const CREATE_NATION = `${NATION}/createNation`;
export const UPDATE_NATION = `${NATION}/updateNation`;
export const DELETE_NATION = `${NATION}/deleteNation`;

// actions
export const actions = {
  GET_NATION_LIST,
  CREATE_NATION,
  UPDATE_NATION,
  DELETE_NATION
};
